import { cashDepositMethod, readCashDepositHistory } from './cashDepositContract';
const id = (value) => typeof value === 'string' && /^[a-f\d]{24}$/i.test(value);
const integer = (value) => Number.isSafeInteger(value) && value >= 0;
const text = (value, maximum = 200) =>
  typeof value === 'string' &&
  value.length <= maximum &&
  !Array.from(value).some(
    (character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127
  );
const stamp = (value) => typeof value === 'string' && Number.isFinite(Date.parse(value));
export const validMerchantReference = (value) =>
  typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9._:-]{2,119}$/.test(value);
export const validCashWireReference = (value) =>
  typeof value === 'string' &&
  !Array.from(value).some(
    (character) =>
      character.charCodeAt(0) < 32 ||
      (character.charCodeAt(0) >= 127 && character.charCodeAt(0) <= 159)
  ) &&
  /^[\x20-\x7e]{3,120}$/.test(value.trim());
export const validMerchantDay = (value) =>
  typeof value === 'string' &&
  /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  Number.isFinite(Date.parse(`${value}T00:00:00.000Z`)) &&
  new Date(`${value}T00:00:00.000Z`).toISOString().slice(0, 10) === value;
export function readAdminCashDeposits(value, page) {
  readCashDepositHistory(value, page);
  if (
    value.items.some(
      (row) =>
        !id(row.actor?._id) ||
        !['name', 'username', 'email'].every((key) => text(row.actor[key])) ||
        !integer(row.paymentRevision) ||
        typeof row.merchantFundingRecorded !== 'boolean' ||
        typeof row.merchantAdverseReviewRecorded !== 'boolean'
    )
  )
    throw new Error('Invalid funding history');
  return value;
}
function readReview(row, deposit, kind) {
  const proof = row?.[kind === 'funding' ? 'merchantFunding' : 'merchantAdverseReview'];
  if (
    !row ||
    row.depositId !== deposit._id ||
    !['ach', 'card'].includes(row.method) ||
    row.method !== cashDepositMethod(deposit) ||
    row.amountCents !== deposit.amountCents ||
    row.currency !== 'USD' ||
    !integer(row.expectedAttemptRevision) ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,199}$/.test(row.realmId || '') ||
    !(row.transactionId === null || /^[A-Za-z0-9._:-]{1,200}$/.test(row.transactionId || '')) ||
    typeof row[kind === 'funding' ? 'canConfirm' : 'canReview'] !== 'boolean' ||
    (kind === 'adverse' && ![null, 15, 60].includes(row.reviewWindowMinutes))
  )
    throw new Error('Invalid merchant review');
  if (
    proof !== null &&
    (!proof ||
      proof.version !== 1 ||
      proof.source !== 'quickbooks_merchant_service_center' ||
      !/^[A-Za-z0-9_-]{16,100}$/.test(proof.requestKey || '') ||
      proof.realmId !== row.realmId ||
      proof.transactionId !== row.transactionId ||
      proof.amountCents !== row.amountCents ||
      proof.currency !== 'USD' ||
      !/^[a-f\d]{64}$/.test(proof.intentHash || '') ||
      (kind === 'funding'
        ? proof.status !== 'Funded' ||
          !id(proof.confirmedBy) ||
          !stamp(proof.recordedAt) ||
          !validMerchantDay(proof.fundedDate) ||
          !validMerchantReference(proof.depositReference)
        : proof.status !== 'no_adverse_items_observed' ||
          !id(proof.reviewedBy) ||
          !stamp(proof.reviewedAt) ||
          !validMerchantReference(proof.reviewReference)))
  )
    throw new Error('Invalid merchant proof');
  if ((row.canConfirm || row.canReview) && !row.transactionId)
    throw new Error('Missing merchant payment');
  return row;
}
export function readCashReviews(funding, adverse, deposit) {
  readReview(funding, deposit, 'funding');
  readReview(adverse, deposit, 'adverse');
  if (
    ['expectedAttemptRevision', 'transactionId', 'realmId'].some(
      (key) => funding[key] !== adverse[key]
    )
  )
    throw new Error('Review changed');
  return { funding, adverse };
}

export function readCashWireClearance(row, deposit) {
  if (
    !row ||
    row.depositId !== deposit._id ||
    row.method !== 'wire' ||
    cashDepositMethod(deposit) !== 'wire' ||
    row.amountCents !== deposit.amountCents ||
    row.currency !== 'USD' ||
    !integer(row.expectedRevision) ||
    typeof row.canConfirm !== 'boolean'
  )
    throw new Error('Invalid wire clearance');
  const proof = row.wireClearance;
  if (
    proof !== null &&
    (!proof ||
      !/^[A-Za-z0-9._:-]{16,100}$/.test(proof.requestKey || '') ||
      !validCashWireReference(proof.sourceReference) ||
      !validMerchantDay(proof.clearedAt) ||
      !stamp(proof.recordedAt) ||
      !id(proof.confirmedBy) ||
      row.canConfirm)
  )
    throw new Error('Invalid wire proof');
  return row;
}
